import { render, staticRenderFns } from "./Adjustwithdraw.vue?vue&type=template&id=2d5814d4&"
import script from "./Adjustwithdraw.vue?vue&type=script&lang=js&"
export * from "./Adjustwithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports